export default __webpack_public_path__ + "static/media/error.684fffd7.svg";